<template>
    <section v-if="!dpp.hideNew && getShowList('new', 'city')" :class="theme" class="property-nearby">
        <div class="grid xs-grid-cols-1">
            <div class="flex" v-if="theme === 'newDpp'">
                <a :href="getMSPLink('new-7')" class="link" v-ga:click>
                  <b class="f4 text-bold">New listings <span class="hidden-xs">in {{dpp.geo.city}}</span></b>
                </a>
            </div>
            <div class="f4 text-bold" v-else>
                <a class="link" :href="getMSPlink">
                    New listings <span class="hidden-xs">in {{dpp.geo.city}}</span>
                </a>
            </div>
            <mvtLazyload ref="lazyloadNearbyCity" :async="true" data-role="propertycard">
                <mvtNearby type="city" filterPath="/new-7/" @completed="completedNearbyCity" :filterId="dpp.propertyId" carousalType="new"></mvtNearby>
            </mvtLazyload>
        </div>
    </section>
</template>
<script src="./property-nearbycity.js"></script>

<style lang="scss">
@use "./property-nearbycity.scss" as *;
</style>
